import { startCase } from 'lodash';

import { KeyValue } from '@angular/common';
import { Component, ChangeDetectionStrategy, Input, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'sn-details',
  host: {
    class: 'sn-details',
  },
  templateUrl: './details.component.html',
  styleUrls: ['./details.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SnDetailsComponent {
  @Input()
  public details: Record<string, any> | Map<string, any> | { [name: string]: any };

  constructor() {}

  public trackByKey(index: number, item: KeyValue<string, any>): string {
    return item.key;
  }

  public toStartCase(text: string): string {
    return startCase(text);
  }
}
